import styled from 'styled-components';

const SelectionTitle = styled.div`
  ${props => props.theme.fonts.selectOption};
  color: ${props => props.theme.colors.greyXXD};
`;

export default styled(SelectionTitle)``;
